import { refreshPortalSession } from '@/api/auth'
import { getOnboardingStatus } from '@/api/onboarding'
import type { PortalSession } from '@/types/api'

/** 重新入会保留原绑定，申请页不能只凭旧会话的 pending/bound 判断去向。 */
export async function resolveOnboardingEntry(cached: PortalSession) {
  const session = cached.bindingStatus === 'unbound' ? cached : await refreshPortalSession()
  if (session.bindingStatus === 'bound') return { session, target: 'home' as const }
  if (session.bindingStatus === 'pending') {
    const status = await getOnboardingStatus()
    if (status.statusCode !== 'reapplication_available') return { session, target: 'result' as const }
  }
  return { session, target: 'apply' as const }
}
